import React, { useState, useEffect } from "react";
import combinedServices from "../../../shared/services/user-service";
import { useNavigate } from "react-router-dom";
import Header from "../../../Components/Layout/Header/Header";
import Footer from "../../../Components/Layout/Footer/Footer";
import "./ProductListing.scss";
import Event1 from "../../../assets/images/event-img1.jpg";
import { useLocation } from 'react-router-dom';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import swal from "sweetalert";

const ProductListing = () => {
  const [productsData, setProductsData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [showAllProducts, setShowAllProducts] = useState(true);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeContent, setNoticeContent] = useState("");
  const [pendingEventId, setPendingEventId] = useState(null);

  const navigate = useNavigate();

  const location = useLocation();
  const storeID = location.state?.storeID;
  console.log("storeID", storeID);

  useEffect(() => {
    if (!storeID) {
      window.location.href = "/";
      return;
    }

    // const fetchNotice = async () => {
    //   try {
    //     const response = await combinedServices.fetchNoticeById(storeID);
    //     if (response.data.data.notice_status === "active") {
    //       setNoticeContent(response.data.data.content);
    //       setNoticeModal(true);
    //     }
    //   } catch (error) {
    //     console.log("No active notice found");
    //   }
    // };

    const fetchProducts = async () => {
      try {
        let productsResponse = await combinedServices.getProductsforUser({ storeID: storeID });
        if (productsResponse?.data?.data) {
          setProductsData(productsResponse.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching Products:", error);
      }
    };

    const fetchEvents = async () => {
      try {
        // Check if user is logged in
        const userInfo = localStorage.getItem("user_info");
        if (!userInfo) {
          console.log("User not logged in, skipping events fetch");
          return;
        }

        let eventsResponse = await combinedServices.getEventsforusers({ storeID: storeID });
        if (eventsResponse?.data?.events) {
          setEventData(eventsResponse.data.events || []);
        }
      } catch (error) {
        console.error("Error fetching Events:", error);
      }
    };

    const initializePage = async () => {
      try {
        // Validate store first
        const response = await combinedServices.getstorebyid(storeID);
        if (!response?.data?.data || !response.data.data.isAvailable) {
          await swal("Warning", "Store is not available", "warning");
          window.location.href = "/";
          return;
        }

        // Only proceed if store is valid
        // await fetchNotice();
        await fetchProducts();
        await fetchEvents();
      } catch (error) {
        await swal("Warning", "Store is not available", "warning");
        window.location.href = "/";
      }
    };

    initializePage();
  }, [navigate, storeID]);


  // useEffect(() => {
  //   const fetchNotice = async () => {
  //     try {
  //       const response = await combinedServices.fetchNoticeById(storeID);
  //       console.log("Notice Response:", response);
  //       if (response.data.data.notice_status === "active") {
  //         setNoticeContent(response.data.data.content);
  //         setNoticeModal(true);
  //       }
  //     } catch (error) {
  //       console.log("No active notice found");
  //     }
  //   };

  //   const fetchProducts = async () => {
  //     try {
  //       let productsResponse = await combinedServices.getProductsforUser({storeID:storeID});
  //       if (productsResponse?.data?.data) {
  //         setProductsData(productsResponse.data.data || []);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching Products:", error);
  //     }
  //   };

  //   const fetchStoreStatus = async () => {
  //     try {
  //       const response = await combinedServices.storeStatus();
  //       const storeData = response?.data?.data?.data?.[0];
  //       if (storeData && !storeData.isAvailable) {
  //         navigate("/Store");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching Store status:", error);
  //       navigate("/");
  //     }
  //   };

  //   fetchNotice();
  //   fetchProducts();
  //   fetchStoreStatus();
  // }, [navigate,storeID]);

  // useEffect(() => {
  //   const fetchEvents = async () => {
  //     try {
  //       let eventsResponse = await combinedServices.getEventsforusers({storeID:storeID});
  //       if (eventsResponse?.data?.events) {
  //         setEventData(eventsResponse.data.events || []);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching Events:", error);
  //     }
  //   };
  //   fetchEvents();
  // }, [storeID]);

  const handleProductClick = (id) => {
    navigate(`/productDetail/${id}`, { state: { storeID } });
  };

  const handleEnterEvent = async (id) => {
    console.log("Enter called");
    const event = eventData.find((evt) => evt.id === id);
    if (event && new Date(event.registration_close) < new Date()) {
      return;
    }
    const noticeShown = await fetchNotice();
    if (noticeShown) {
      setPendingEventId(id); // Store the event ID to navigate after notice closes
    } else {
      navigate(`/eventTicket/${id}`, { state: { storeID } });
    }
    // navigate(`/eventTicket/${id}`, { state: { storeID } });
  };

  const myOrders = () => {
    navigate(`/MyOrders`, { state: { storeID } });
  };

  const handleEnterHereClick = async () => {
    console.log("Enter Heere caleed");
    // Redirect to the first event if available
    const event = eventData.find((evt) => evt.id === eventData[0].id);
    if (event && new Date(event.registration_close) < new Date()) {
      return;
    }
    if (eventData.length > 0) {
      const noticeShown = await fetchNotice();
      if (noticeShown) {
        setPendingEventId(event.id);
      } else {
        navigate(`/eventTicket/${event.id}`, { state: { storeID } });
      }
      // navigate(`/eventTicket/${eventData[0].id}`);
    }
  };

  const fetchNotice = async () => {
    try {
      const response = await combinedServices.fetchNoticeById(storeID);
      const noticeAckStatus = localStorage.getItem("notice_ack");
      if (!noticeAckStatus && response.data.data.notice_status === "active") {
        setNoticeContent(response.data.data.content);
        setNoticeModal(true);
        return true;
      }
      return false;
    } catch (error) {
      console.log("No active notice found");
      return false;
    }
  };

  const handleCloseNotice = async () => {
    localStorage.setItem("notice_ack", "yes");
    setNoticeModal(false);
    
    // Navigate to pending event if exists
    if (pendingEventId) {
      navigate(`/eventTicket/${pendingEventId}`, { state: { storeID } });
      setPendingEventId(null);
    }
  }

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '92%', sm: '80%', md: '75%' },
    maxWidth: '900px',
    height: '90vh',
    bgcolor: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 25px 80px rgba(0,0,0,0.2)',
    p: 0,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column'
  };

  return (
    <>
      <div className="mainCon">
        <Header />
        <div className="mainCont">
          <section className="ContactOuter pt-5 pb-5">
            <div className="container">
              <div className="d-block d-sm-flex flex-wrap justify-content-between align-items-end pb-5">
                <div>
                  <div className="mb-3 productHd">
                    <span
                      style={{ fontSize: "35px", cursor: "pointer" }}
                      onClick={()=>handleEnterHereClick()}
                    >
                      {eventData.length === 0 ? "No Events TO Enter" : "Enter Here"}
                    </span>
                  </div>
                </div>

                <div className="mt-3 mt-sm-0">
                  <div className="filBtnWrp">
                    <button className="nambaBtn" onClick={myOrders}>
                      My Orders
                    </button>
                  </div>
                  {/* <select className="formSelect small">
                    <option>Sort by: Relevance</option>
                  </select> */}
                </div>
              </div>

              <div className="mb-5">
                {eventData.length === 0 ? (
                  <div className="text-center py-5">
                    <p style={{ fontSize: "18px", color: "#666" }}>No events available</p>
                  </div>
                ) : (
                  <>
                    <ul className="d-flex flex-wrap p-0 productList">
                      {eventData
                        .slice(0, showAllEvents ? eventData.length : 8)
                        .map((event, index) => (
                          <li
                            className="col-6 col-md-3"
                            key={event.id || index}
                            onClick={() => handleEnterEvent(event.id)}
                          >
                            <div className="inner">
                              <div className="img">
                                <img
                                  src={
                                    event.image?.startsWith("https://nambaweb.s3")
                                      ? event.image
                                      : Event1
                                  }
                                  alt={event.full_title || `Event ${index + 1}`}
                                />
                                {new Date(event.registration_close) < new Date() && (
                                  <div className="registration-closed-overlay">
                                    Event Closed
                                  </div>
                                )}
                              </div>
                              <div className="name mt-3">
                                {event.full_title || "Event Title"}
                                <span className="d-block">
                                  {new Date(event.event_start).toLocaleDateString(
                                    "en-US",
                                    {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric"
                                    }
                                  )}{" "}
                                  -{" "}
                                  {new Date(event.event_end).toLocaleDateString(
                                    "en-US",
                                    {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric"
                                    }
                                  )}
                                </span>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                    {eventData.length > 8 && (
                      <div className="text-center mt-4">
                        <button
                          className="nambaBtn"
                          style={{ marginLeft: '0px' }}
                          onClick={() => setShowAllEvents(!showAllEvents)}
                        >
                          {showAllEvents
                            ? "Show Less Tickets"
                            : "Show More Tickets"}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div>
                <div className="productHd mb-3">
                  <span style={{ fontSize: "35px" }}>PRODUCTS</span>
                </div>
                {productsData.length === 0 ? (
                  <div className="text-center py-5">
                    <p style={{ fontSize: "18px", color: "#666" }}>No products available</p>
                  </div>
                ) : (
                  <ul className="d-flex flex-wrap productList p-0" style={{ gap: "0px" }}>
                    {productsData
                      .slice(0, showAllProducts ? productsData.length : 8)
                      .map((product) => {
                        const images = JSON.parse(product.images || "[]");
                        const isOutOfStock = product.totalQuantity === "0";

                        return (
                          <li
                            className="col-6 col-md-3"
                            key={product.product_id}
                            onClick={() =>
                              !isOutOfStock &&
                              handleProductClick(product.product_id)
                            }
                            style={{
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.4 : 1
                            }}
                          >
                            <div className="inner">
                              <div className="img">
                                <img
                                  src={
                                    images[0] || "https://via.placeholder.com/150"
                                  }
                                  alt={product.product_name || "Product"}
                                />
                              </div>
                              <div
                                className="name mt-3"
                                style={{
                                  color: isOutOfStock ? "red" : "inherit"
                                }}
                              >
                                {product.product_name || "Product Name"}
                                {isOutOfStock && <span> (Out of Stock)</span>}
                                <span className="d-block pt-1">
                                  $
                                  {parseFloat(product.retail_price || 0).toFixed(
                                    2
                                  )}{" "}
                                  USD
                                </span>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                )}
                {/* {productsData.length > 8 && (
                  <div className="text-center mt-4">
                    <button
                      className="nambaBtn"
                      style={{marginLeft:'0px'}}
                      onClick={() => setShowAllProducts(!showAllProducts)}
                    >
                      {showAllProducts
                        ? "Show Less Products"
                        : "Show More Products"}
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
      <Modal
        open={noticeModal}
        onClose={() => setNoticeModal(false)}
        aria-labelledby="notice-modal"
        BackdropProps={{
          sx: { backgroundColor: 'rgba(0,0,0,0.6)' }
        }}
      >
        <Box sx={modalStyle}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            bgcolor: '#fff'
          }}>
            <Box sx={{
              background: 'linear-gradient(135deg, #01458b 0%, #0066cc 100%)',
              color: 'white',
              px: { xs: 3, sm: 4 },
              py: 3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '4px solid #0095fd'
            }}>
              <Box>
                <Box sx={{ fontSize: '18px', fontWeight: 600, opacity: 0.9, letterSpacing: '1px' }}>Getting</Box>
                <Box sx={{ fontSize: '28px', fontWeight: 800, mt: 0.5 }}>Started</Box>
              </Box>
              {/* <IconButton
                onClick={() => setNoticeModal(false)}
                sx={{
                  color: 'white',
                  bgcolor: 'rgba(255,255,255,0.15)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
                  width: 44,
                  height: 44
                }}
              >
                <CloseIcon sx={{ fontSize: 28 }} />
              </IconButton> */}
            </Box>
            <Box sx={{
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
              px: { xs: 3, sm: 4 },
              py: 2,
              '&::-webkit-scrollbar': {
                width: '10px'
              },
              '&::-webkit-scrollbar-track': {
                bgcolor: '#f1f1f1'
              },
              '&::-webkit-scrollbar-thumb': {
                bgcolor: '#01458b',
                borderRadius: '5px',
                '&:hover': { bgcolor: '#0066cc' }
              }
            }}>
              <Box
                sx={{
                  '& img': {
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '12px',
                    mb: 1.5,  // Changed from 3
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  },
                  '& p': {
                    mb: 1.25,  // Changed from 2.5
                    lineHeight: 1.6,  // Changed from 1.9
                    color: '#333',
                    fontSize: '18px',
                    fontWeight: 500
                  },
                  '& h1': { fontSize: '36px', fontWeight: 800, color: '#01458b', mb: 1.25, mt: 0 },  // Changed mb from 2.5
                  '& h2': { fontSize: '30px', fontWeight: 700, color: '#01458b', mb: 1.25, mt: 1.75 },  // Changed mb from 2.5, mt from 3.5
                  '& h3': { fontSize: '26px', fontWeight: 700, color: '#0066cc', mb: 1.25, mt: 1.5 },  // Changed mb from 2.5, mt from 3
                  '& h4, & h5, & h6': { fontWeight: 700, color: '#01458b', mb: 1, mt: 1.25, fontSize: '20px' },  // Changed mb from 2, mt from 2.5
                  '& ul, & ol': {
                    mb: 1.25,  // Changed from 2.5
                    pl: 3,
                    '& li': {
                      mb: 0.9,  // Changed from 1.8
                      lineHeight: 1.6,  // Changed from 1.9
                      color: '#333',
                      fontSize: '17px'
                    }
                  },
                  '& strong': { fontWeight: 800, color: '#01458b' },
                  '& em': { fontStyle: 'italic', color: '#0066cc' },
                  '& a': { color: '#0095fd', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } },
                  '& blockquote': { borderLeft: '4px solid #0095fd', pl: 2.5, ml: 0, py: 0.75, bgcolor: '#f5f9ff', px: 2.5, borderRadius: '4px', fontSize: '17px' }  // Changed py from 1.5
                }}
                dangerouslySetInnerHTML={{ __html: noticeContent }}
              />
            </Box>
            <Box sx={{
              bgcolor: '#f8f9fa',
              px: { xs: 3, sm: 4 },
              py: 1.25,
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => handleCloseNotice()}
                style={{
                  padding: '10px 28px',
                  background: 'linear-gradient(135deg, #01458b 0%, #0066cc 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(1, 69, 139, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(1, 69, 139, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(1, 69, 139, 0.3)';
                }}
              >
                Got It
              </button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ProductListing;
